export default __webpack_public_path__ + "static/media/Menu-Mobile.ae521a4d.svg";